<template>
  <div class="sensors-page">
    <div class="sensors-page__header">
      <Title :title="$t('sensors')" />
    </div>
    <Tabs :tabs="tabs" @select-tab="setActiveTab" />
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component';

import router from '@/router';

import { tabs } from './configs';

@Options({
  name: 'Sensors',
  data() {
    return {
      tabs
    };
  },
  created() {
    this.show();
  },
  methods: {
    show() {
      if (this.$route.name === 'Sensors') {
        this.setActiveTab('SensorGroups');
      }
    },
    setActiveTab(tabValue: string) {
      router.push({ name: tabValue });
    }
  }
})
export default class Sensors extends Vue {}
</script>

<style lang="scss" scoped>
.sensors-page {
  .sensors-page__header {
    padding: 24px;
    padding-bottom: 32px;
  }
}
</style>
